<template>
    <div>
        <b-form @submit.prevent="onSubmit">
            <b-row v-if="processoCompra == null" class="mt-3">
                <b-col cols="12" class="d-flex justify-content-end">
                    <b-button variant="primary" @click="abrirModal">
                        +
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-table small :items="contratoForm.itensContratos" :fields="fields" responsive>

                        
                        <template #cell(valorUnitario)="data">
                            <LgFormInput :disabled="processoCompra != null" class='mt-3'
                                v-model="data.item.valorUnitario" type="text" placeholder="Valor Unitário"
                                @input="formatValorUnit(data.item)" />
                        </template>
                        <template #cell(quantidade)="data">
                            <b-form-input @input="handleQuantidade(data.item)" style="height: 20px;"
                                v-model="data.item.quantidade" type="number" min="1" required></b-form-input>
                        </template>

                        <template #cell(actions)="data">
                            <b-button size="sm" variant="danger" @click="remover(data.index)">
                                <b-icon icon="trash"></b-icon>

                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-form>
        <ModalConsultaProdutoCadastroEssencial v-if='showModalConsultaProdutoCadastroEssencial'
            @onselect="handleSelectProduto" invalidFeedback="Informe um produto!" :prefix="prefix" />

    </div>
</template>

<script>
import ModalConsultaProdutoCadastroEssencial from "@/core/components/Modals/ModalConsultaProdutoCadastroEssencial.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ResourceService from "@/core/api/ResourceService"
export default {
    name: "ContratoForm",
    components: {
        ModalConsultaProdutoCadastroEssencial,
        LgFormInput
    },
    props: {
        processoCompra: {
            type: Object,
            default: null
        },

        id: {
            type: String,
            default: ''
        },

        prefix: {
            type: String,
            default: ""
        },
        contratoFormParam: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModalConsultaProdutoCadastroEssencial: false,
            contratoForm: this.contratoFormParam,
            fields: this.processoCompra != null ?
                [
                    { key: 'produto.descricaoResumida', label: 'Produto' },
                    { key: 'quantidade', label: 'Quantidade' },
                    { key: 'quantidadeRetirada', label: 'Quantidade Retirada' },
                    { key: 'qtdMaxima', label: 'Quantidade Máxima' },

                    { key: 'valorUnitario', label: 'Valor' },
                    { key: 'actions', label: 'Ações' },
                ]
                : [
                    { key: 'produto.descricaoResumida', label: 'Produto' },
                    { key: 'quantidade', label: 'Quantidade' },
                    { key: 'valorUnitario', label: 'Valor' },
                    { key: 'actions', label: 'Ações' },
                ],
        };
    },
    methods: {
        handleQuantidade(item) {
            if (this.processoCompra != null) {
                if (item.quantidade > item.qtdMaxima) {
                    this.$notify({
                        message: `A quantidade do item ${item.descricaoResumida} não pode exceder ${item.qtdMaxima}.`,
                        type: 'danger',
                        solid: true
                    });
                    item.quantidade = 0;
                    return
                }
            }
        },
        formatValorUnit(item) {
            item.valorUnit = item.valorUnit.replace(',', '.')
        },
        abrirModal() {
            this.showModalConsultaProdutoCadastroEssencial = true;
        },

        handleSelectProduto(item) {

            this.showModalConsultaProdutoCadastroEssencial = false;
            if (item && item.id)
                this.contratoForm.itensContratos.push({ produto: item, valor: "", quantidade: "" })

        },
        remover(index) {
            this.contratoForm.itensContratos.splice(index, 1);
        },

    },
    async beforeMount() {
        if (!this.isEditMode) {
            this.busy = true;
            var { data } = await new ResourceService('/api/processocompra').get(`${this.processoCompra.id}/${0}/itens-para-contrato`);
            this.contratoForm.itensContratos = data;
            this.busy = false;

        }
    }
};
</script>

<style scoped></style>
